<template>
  <div
    class="row-header grid"
    :class="{ 'd-flex justify-content-between': !lead }"
    ref="row"
    >
    <h2
    class="font-responsive-large font-responsive-lg-larger"
    :class="{ 'g-12 g-md-6': lead }"
    :style="style"
    v-html="mergedTitle"
    tabindex="0"
    :id="id"
    />
    <div v-if="linkText && href" class="g-12 g-md-6 d-flex justify-content-end">
      <a
        class="font-responsive-small font-responsive-lg-body -user-select-none"
        :href="href"
        :style="style"
        @click="$emit('link-click', href)"
        >{{ linkText }}</a
      >
    </div>
    <div
      v-else-if="lead"
      class="row-header-lead font-responsive-body g-12 g-md-6"
      :style="style"
      v-html="lead"
    />
  </div>
</template>
<script>

export default {
  name: 'RowHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: String,
    linkText: String,
    href: String,
    lead: String,
    fontColor: {
      type: String,
      default: ''
    },
    id: String
  },
  computed: {
    mergedTitle () {
      let str = `<span>${this.title}</span>`;
      if (this.subTitle && this.subTitle.length > 1) {
        str = `<span class="-bold">${this.title}</span>`;
        str += ` <span class="-subtitle -thin">${this.subTitle}</span>`;
      }
      return str;
    },
    style () {
      return this.fontColor.length ? { color: `#${this.fontColor.replace('#', '')}` } : {};
    }
  }
};
</script>
<style lang="scss">
@import "@/scss/defaults.scss";
.row-header {
  h2 p {
    margin-bottom: 0;
  }
  &-lead {
    margin-top: 18px;
    @include media-breakpoint-up(md) {
      margin-top: 0;
    }
  }
}
</style>
